import { useState, useEffect } from 'react';
import ProductServ from '../service/ProductServ';

let cachedConfig = null;

export const useUploadConfig = () => {
    const [uploadConfig, setUploadConfig] = useState(cachedConfig || { profiles: {}, features: {} });

    useEffect(() => {
        if (!cachedConfig) {
            ProductServ.getUploadConfig().then(res => {
                const config = res.data || res;
                cachedConfig = config;
                setUploadConfig(config);
            }).catch(err => {
                console.error("Failed to fetch upload config:", err);
            });
        }
    }, []);

    const getProfile = (profileName) => {
        const key = profileName.toUpperCase();
        return uploadConfig.profiles[key] || { maxUploadMB: 5, targetKB: 200, width: 800, height: 800 };
    };

    return { uploadConfig, getProfile };
};
